import React, {FunctionComponent} from 'react';
import './Block.less';
import {BlockTitle} from 'elements/block-title/BlockTitle';

interface BlockProps {
	title: string,
	titleControl?: JSX.Element,
	isNonScalable?: boolean,
	isShowTitle?: boolean,
	subTitleControl?: JSX.Element
}

export const Block: FunctionComponent<BlockProps> = (
	{
		title,
		titleControl,
		children,
		isNonScalable,
		isShowTitle = true,
		subTitleControl,
	}
) => {
	return <div className={`block ${isNonScalable ? 'block--non-scalable' : ''}`}>
		{
			isShowTitle && <div className="block__title-container">
				<label className="block__title">
					<BlockTitle text={title} isNonScalable={isNonScalable}/>
				</label>
				{
					titleControl && (
						<div className="block__title-control">
							{titleControl}
						</div>
					)
				}
			</div>
		}
		{ subTitleControl &&
			<div className="block__sub-title-control">
				{subTitleControl}
			</div>
		}
		<div className="block__contents">
			{children}
		</div>
	</div>;
};
